import { GraphQLClient } from 'graphql-request'

export const graphQLClient = new GraphQLClient(process.env.REACT_APP_API_URL!, {
  headers: {
    'X-API-KEY': process.env.REACT_APP_X_API_KEY!,
  },
})
